import { Flex } from "antd";
import styled from "styled-components";

export const StyledSKURaw = styled(Flex)`
    flex-direction: column;
    gap: 8px;
    padding-bottom: 12px;
    padding-right: 12px;
    border-bottom: 1px solid ${({ theme }) => theme.secondaryBorderColor};

    &:first-child {
        padding-top: 0;
    }

    &:last-child {
        border-bottom: none;
        padding-bottom: 0;
    }
`;

export const StyledNestedAccordionWrapper = styled.div`
    padding-top: 16px;
    width: 100%;
    border-radius: 10px;
    overflow: hidden;
    background-color: ${(props) => props.theme.collapseHeaderBackground};
`;
